var map = {
	"./bootstrap.png": 5875,
	"./css.png": 4102,
	"./database.png": 9693,
	"./draw.png": 5450,
	"./figma.png": 5519,
	"./gaming.png": 3633,
	"./github.png": 9056,
	"./gta.png": 7542,
	"./html.png": 6464,
	"./javascript.png": 857,
	"./kitty.png": 7841,
	"./movie.png": 7582,
	"./nodejs.png": 9151,
	"./photoshop.png": 5423,
	"./rdr.png": 8158,
	"./react.png": 6961,
	"./sass.png": 628,
	"./storybook.png": 6558,
	"./typescript.png": 3120,
	"./unity.png": 1917,
	"./vscode.png": 8028,
	"./vuforia.png": 3287,
	"./xbox.png": 6244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1552;